export default "__VITE_ASSET__BkFqj5zy__"